import { Box } from '@mui/system';
import { Button } from '@openx/components-core/lib/Button/Button';
import { useCallback } from 'react';
import type { OpenXAgentToolData } from '../../context/OpenXAgentContext';
import { useOpenXAgentContext } from '../../context/useOpenXAgentContext';
import { getOpenXAgentGradient } from '../colors';
import type { OpenXAgentTool } from '../Home/utils/consts';
import { OpenXAgentIcon } from '../icons/OpenXAgentIcon';

type ToolCallButtonProps = {
  isAllowed: boolean;
  isLoading: boolean;
  toolId: OpenXAgentTool;
  toolData: OpenXAgentToolData;
  name: string;
  dataTest?: string;
};

export const ToolCallButton = ({ isAllowed, isLoading, toolId, toolData, name, dataTest }: ToolCallButtonProps) => {
  const { setActiveTool, setIsOpenXAgentOpen } = useOpenXAgentContext();

  const handleClick = useCallback(() => {
    setActiveTool({
      toolId: toolId,
      toolData: toolData,
    });
    setIsOpenXAgentOpen(true);
  }, [setActiveTool, setIsOpenXAgentOpen, toolId, toolData]);

  if (!isAllowed) return null;

  return (
    <Button
      loading={isLoading}
      onClick={handleClick}
      {...(dataTest && { 'data-test': dataTest })}
      startIcon={
        <Box sx={{ mb: 0.25 }}>
          <OpenXAgentIcon width={16} height={16} />
        </Box>
      }
      sx={{ background: theme => getOpenXAgentGradient(theme) }}
    >
      {name}
    </Button>
  );
};
